import React, { memo } from 'react'
import { Icon, Text } from 'common-components'
import * as Styled from './styled'
import { IProps } from './types'

const DropdownList: React.FC<IProps> = ({
  data,
  onItemClick,
  selectedItemKey
}) => {
  return (
    <Styled.DropdownListWrapper>
      {data.map(item => {
        const { key, label, icon } = item
        const isSelected = key === selectedItemKey

        return (
          <Styled.DropdownListItem
            key={key}
            $isSelected={isSelected}
            onClick={() => onItemClick(item)}
          >
            {!!icon && <Icon icon={icon} size="small" color="secondaryDark" />}
            <Text type="h2" color="secondaryDark">
              {label}
            </Text>
          </Styled.DropdownListItem>
        )
      })}
    </Styled.DropdownListWrapper>
  )
}

export default memo(DropdownList)
